<section class="bg-white p-6 space-y-12">
  <!-- ▓▓▓ OWNERSHIP DETAILS ▓▓▓ -->
  <div>
    <h2 class="text-lg font-bold text-dc-navy">
      {{ "COMPINFO.OWNERSHIP.TITLE" | translate }}
    </h2>

    <!-- overall chip -->
    @if (ownershipDone) {
    <span class="dc-status-active mt-2 inline-block">
      {{ "COMPINFO.STATUS.COMPLETED" | translate }}
    </span>
    }

    <p class="text-xs mt-1">
      {{ "COMPINFO.OWNERSHIP.SUBTITLE" | translate }}
    </p>

    <!-- partner / manager cards -->

    <div class="grid md:grid-cols-3 gap-6 mt-6">
      <!-- Add partner -->
      @if (partners.length < 1) {
      <div class="border-blue relative card-edge-cut">
        <div class="card-body">
          <h3 class="font-semibold text-dc-navy mb-2">
            {{ "COMPINFO.CARD.PARTNER.TITLE" | translate }}
          </h3>
          <p class="text-sm text-dc-navy!">
            {{
              "COMPINFO.CARD.PARTNER.DESC" | translate : { n: requiredPartners }
            }}
          </p>
          <app-button
            classesName="card-edge-cut-primary mt-6"
            [label]="
              'COMPINFO.CARD.PARTNER.BTN'
                | translate : { n: partners.length + 1 }
            "
            (onBtnClick)="addPartner()"
            [disabled]="partners.length >= requiredPartners"
          ></app-button>
          <span class="corner-edge-navy"></span>
        </div>
      </div>
      } @if (partners.length > 0) { @for (owner of partners; track owner) {
      <div>
        <app-membership-owner
          [owner]="owner"
          (onActionClick)="viewOwnerDetail($event)"
        />
      </div>
      } }

      <!-- Add manager -->
      @if (managers.length < 1) {
      <div class="border-blue relative card-edge-cut">
        <div class="card-body">
          <h3 class="font-semibold text-dc-navy mb-2">
            {{ "COMPINFO.CARD.MANAGER.TITLE" | translate }}
          </h3>
          <p class="text-sm text-dc-navy!">
            {{
              "COMPINFO.CARD.MANAGER.DESC" | translate : { n: requiredManagers }
            }}
          </p>
          <app-button
            classesName="card-edge-cut-primary mt-6"
            [label]="'COMPINFO.CARD.MANAGER.BTN' | translate"
            (onBtnClick)="addManager()"
            [disabled]="managers.length >= requiredManagers"
          ></app-button>
          <span class="corner-edge-navy"></span>
        </div>
      </div>
      } @if (managers.length > 0) { @for (manager of managers; track manager) {
      <div>
        <app-membership-owner
          [owner]="manager"
          (onActionClick)="viewOwnerDetail($event)"
        />
      </div>
      } }
    </div>
    <div class="btn-section buttons-group">
      <app-button
        [type]="'button'"
        [label]="'BUTTONS.ADD_OWNER' | translate"
        classesName="card-edge-cut-white"
        (onBtnClick)="isOwnerModalOpen = true"
      />

      <!-- continue -->
      <app-button
        classesName="card-edge-cut-primary"
        [label]="'BUTTONS.CONTINUE' | translate"
        (onBtnClick)="continue()"
      ></app-button>
    </div>
  </div>

  <!--  UPLOAD DOCUMENTS  -->
  <section class="space-y-4">
    <h1 class="section-heading">
      {{ "DOCUMENTS.TITLE" | translate }}
    </h1>
    <div class="fields-container">
      <div class="field-control">
        <app-file
          [title]="'DOCUMENTS.TRADE_LICENSE_TITLE' | translate"
          [description]="'DOCUMENTS.TRADE_LICENSE_NOTE' | translate"
          [attachments]="filesList"
          (onUploadRemove)="handleFileUpload($event)"
          (removeFile)="handleFileRemove($event)"
          [chooseFromExisting]="false"
        />
      </div>

      <div class="field-control">
        <app-file
          [title]="'DOCUMENTS.MOA_TITLE' | translate"
          [attachments]="filesList"
          (onUploadRemove)="handleFileUpload($event)"
          (removeFile)="handleFileRemove($event)"
          [chooseFromExisting]="false"
        />
      </div>
    </div>
  </section>

  <div class="btn-section buttons-group">
    <app-button
      [type]="'button'"
      [label]="'BUTTONS.SUBMIT' | translate"
      classesName="btn-edge-cut  btn-width-auto"
      (onBtnClick)="(false)"
    />

    <app-button
      [type]="'button'"
      [label]="'BUTTONS.SAVE_CLOSE' | translate"
      classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
      (onBtnClick)="(false)"
    />
  </div>
</section>

<!-- Add Owner/Manager Modal -->
@if (isOwnerModalOpen) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="isOwnerModalOpen = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "OWNER_FORM.TITLE" | translate }}
    </h1>
    <!-- content -->
    <app-add-owner-partner
      [(isOpen)]="isOwnerModalOpen"
      [showAction]="true"
      (onBtnClick)="onOwnerSubmit($event)"
    ></app-add-owner-partner>
  </div>
</div>
}
